import { Field } from '@/components/ui/field'
import { Input } from '@/components/ui/input'
import { RISER_MAX_FEET } from '@lib/helpers/riser'

/** What RiserFields shows and reports: both numbers as typed. */
interface RiserFieldsProps {
  idPrefix: string
  widthFeet: string
  lengthFeet: string
  onWidthFeet: (value: string) => void
  onLengthFeet: (value: string) => void
  /** Set when both numbers are filled in and they are not a unit a plan can lay out. */
  error: string | null
}

/**
 * The two numbers a riser is: how wide and how long one unit is. There is no
 * drawing. A plan lays a riser out as a runway of whole units end to end, and
 * each unit draws one from stock. Every form that can create a piece uses this,
 * so a venue, a vendor, and a client bringing their own ask it the same way.
 */
export function RiserFields({
  idPrefix,
  widthFeet,
  lengthFeet,
  onWidthFeet,
  onLengthFeet,
  error,
}: RiserFieldsProps) {
  return (
    <>
      <Field label="Unit width (ft)" htmlFor={`${idPrefix}-riser-width`} hint="How wide one unit is — and so every runway made of it.">
        <Input
          id={`${idPrefix}-riser-width`}
          type="number"
          min={0.01}
          max={RISER_MAX_FEET}
          step="0.01"
          value={widthFeet}
          onChange={(e) => onWidthFeet(e.target.value)}
          placeholder="e.g. 4"
        />
      </Field>
      <Field
        label="Unit length (ft)"
        htmlFor={`${idPrefix}-riser-length`}
        hint="How long one unit is. A runway on a plan is whole units end to end: three 4 × 8 ft units make a 4 × 24 ft runway, and use three from stock."
        {...(error !== null ? { error } : {})}
      >
        <Input
          id={`${idPrefix}-riser-length`}
          type="number"
          min={0.01}
          max={RISER_MAX_FEET}
          step="0.01"
          value={lengthFeet}
          onChange={(e) => onLengthFeet(e.target.value)}
          placeholder="e.g. 8"
        />
      </Field>
    </>
  )
}
